import { Card, Image, Text, Button, Flex, Badge, createStyles } from "@mantine/core";
import { Carousel } from "@mantine/carousel";
import { Link } from "react-router-dom";

const useStyles = createStyles((theme) => ({
  card: {
    overflow: "hidden",
    border: `1px solid ${theme.colors.gray[2]}`,
    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
    "&:hover": {
      borderColor: theme.colors.orange[2],
      boxShadow: theme.shadows.sm,
    },
    "&:hover $title": {
      textDecoration: "underline",
      textDecorationColor: theme.colors.orange[5],
      textUnderlineOffset: 3,
    },
  },
  imageWrapper: {
    position: "relative",
    aspectRatio: "1 / 1",
    flexShrink: 0,
    overflow: "hidden",
    lineHeight: 0,
    backgroundColor: theme.colors.gray[0],
    "& .mantine-Carousel-root": { height: "100%" },
    "& .mantine-Carousel-viewport": { height: "100%" },
    "& .mantine-Carousel-slide": { height: "100%" },
    "& .mantine-Image-image": {
      objectFit: "contain",
    },
  },
  content: {
    padding: theme.spacing.md,
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  details: {
    flex: 1,
  },
  title: {
    transition: "text-decoration-color 0.2s ease",
    lineHeight: 1.4,
    height: "2.8em",
    marginBottom: theme.spacing.xs,
    overflow: "hidden",
  },
  summary: {
    lineHeight: 1.5,
    height: "3em",
    overflow: "hidden",
  },
  priceBlock: {
    minHeight: "2.625rem",
    marginTop: theme.spacing.xs,
  },
  priceLine: {
    fontSize: theme.fontSizes.sm,
    color: theme.colors.gray[7],
    fontWeight: 500,
    lineHeight: 1.5,
  },
  cta: {
    marginTop: "auto",
    paddingTop: theme.spacing.sm,
  },
  soldOutBadge: {
    position: "absolute",
    top: theme.spacing.sm,
    right: theme.spacing.sm,
    zIndex: 1,
  },
}));

export default function ProductCard({ product }) {
  const { classes } = useStyles();
  const imgList = product.image;
  const altBase = `${product.title} - 馬來西亞貓山王朝榴槤產品`;
  const imgListCard = imgList.map((img, i) => (
    <Carousel.Slide key={i}>
      <Image
        fit="contain"
        height="100%"
        width="100%"
        src={img}
        alt={imgList.length > 1 ? `${altBase} 圖片${i + 1}` : altBase}
        loading="lazy"
      />
    </Carousel.Slide>
  ));

  return (
    <Card className={classes.card} shadow="xs" padding={0} radius="lg" h="100%">
      <Flex direction="column" m={0} h="100%">
        <Card.Section className={classes.imageWrapper}>
          {product.sold_out && (
            <Badge className={classes.soldOutBadge} color="gray" variant="filled" size="lg">
              已售罄
            </Badge>
          )}
          {imgList.length > 1 ? (
            <Carousel maw="100%" mx="auto">
              {imgListCard}
            </Carousel>
          ) : (
            <Image fit="contain" height="100%" width="100%" src={imgList[0]} alt={altBase} loading="lazy" />
          )}
        </Card.Section>

        <div className={classes.content}>
          <div className={classes.details}>
            <Text className={classes.title} weight={600} size="md" color="dark.7" lineClamp={2}>
              {product.title}
            </Text>

            <Text className={classes.summary} size="sm" color="dimmed" lineClamp={2}>
              {product.summary}
            </Text>

            <div className={classes.priceBlock}>
              {product.pricingNote && (
                <Text className={classes.priceLine}>{product.pricingNote}</Text>
              )}
            </div>
          </div>

          <div className={classes.cta}>
            {product.sold_out ? (
              <Button variant="light" color="gray" fullWidth radius="lg" disabled>
                已售罄
              </Button>
            ) : (
              <Link to="/contact" style={{ textDecoration: "none" }}>
                <Button variant="light" color="orange" fullWidth radius="lg">
                  查詢訂銷
                </Button>
              </Link>
            )}
          </div>
        </div>
      </Flex>
    </Card>
  );
}
